module.exports = __webpack_public_path__ + "static/media/doggos.bc7b56d4.jpg";